import { Navigate, useLocation, useParams } from "react-router-dom";
import { getLanguageFromPath, getLocalizedPath } from "../utils/urlUtils";

/**
 * Redirects legacy /tag/:tagName URLs (including language-prefixed ones)
 * to the home page with a ?tag= query parameter.
 */
export function TagRedirect(): JSX.Element {
  const location = useLocation();
  const { tagName } = useParams();

  if (!tagName) {
    return <Navigate to="/" replace />;
  }

  const language = getLanguageFromPath(location.pathname);
  const search = new URLSearchParams(location.search);
  search.set("tag", decodeURIComponent(tagName));
  const basePath = getLocalizedPath("/", language);

  return <Navigate to={`${basePath}?${search.toString()}`} replace />;
}
